import * as React from 'react'
import styled from 'styled-components'

import { windowSizeBreakpoints } from 'utils/breakpoints'

interface Props {
  contact: LockerUser
  isLast: boolean
  onSelectContact: (contact: LockerUser) => void
}

const ContactInfosLocker = ({ contact, isLast, onSelectContact }: Props) => {
  const { firstName, lastName, emailAddress } = contact

  return (
    <MainContainer>
      <ContactContainer onClick={() => onSelectContact(contact)}>
        <div>
          <PictureContainer>
            <ContactLetters>
              {firstName?.[0] || emailAddress?.[0]}
              {lastName?.[0] || emailAddress?.[0]}
            </ContactLetters>
          </PictureContainer>
        </div>
        <ContactInfosContainer>
          {(!!lastName || !!firstName) && (
            <ContactName>
              {lastName} {firstName}
            </ContactName>
          )}
          {!!emailAddress && <ContactMail>{emailAddress}</ContactMail>}
        </ContactInfosContainer>
      </ContactContainer>
      {!isLast && <BlueLineBreak />}
    </MainContainer>
  )
}

// CONTAINERS

const MainContainer = styled('div')`
  position: relative;
`
const ContactContainer = styled('button')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 10px;
  margin: 3px 10px 3px 10px;
  padding: 12px 14px 12px 14px;
  &:hover {
    background-color: ${(props) => props.theme.colors.lightGrey};
  }
  @media only screen and (max-width: ${windowSizeBreakpoints.phone}px) {
    margin: 3px 0px;
    padding: 12px 0px;
  }
`
const ContactInfosContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
  width: 197px;
  word-wrap: break-word;
  @media only screen and (max-width: ${windowSizeBreakpoints.phone}px) {
    width: 100%;
  }
`
const PictureContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33px;
  height: 33px;
  border-radius: 28px;
  background-color: ${(props) => props.theme.colors.mediumDarkGrey};
`

// TEXTES

const ContactName = styled('p')`
  ${(props) => props.theme.fonts.bodyBold};
  color: ${(props) => props.theme.colors.darkGrey};
  margin: 0px;
`
const ContactMail = styled('p')`
  ${(props) => props.theme.fonts.label};
  color: ${(props) => props.theme.colors.darkGrey};
  margin: 0px;
`
const ContactLetters = styled('p')`
  ${(props) => props.theme.fonts.subtitleBold};
  color: ${(props) => props.theme.colors.darken};
  text-transform: uppercase;
  margin-left: 1.5px;
`

// AUTRES

const BlueLineBreak = styled('div')`
  width: 50px;
  height: 3px;
  background-color: ${(props) => props.theme.colors.blue};
  border-radius: 2px;
  margin-left: 24px;
`

export default ContactInfosLocker
